/**
 * Default bot logo — a single inline SVG mark used everywhere a bot message
 * appears (inbox live thread + historic modal). Swap the markup here to
 * rebrand the bot logo across the app.
 *
 * Rendered as a real <svg> element (not an <img>), so it scales crisply and
 * inherits sizing from its wrapper.
 *
 * @param {{ className?: string }} props
 */
export default function BotLogoMark({ className = "" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      role="img"
      aria-label="Bot"
      className={`h-full w-full ${className}`.trim()}
    >
      {/* Rounded background tile in the bot-bubble violet family. */}
      <rect x="0" y="0" width="32" height="32" rx="9" fill="#7c3aed" />
      {/* Antenna. */}
      <line x1="16" y1="6.5" x2="16" y2="9.5" stroke="#ede9fe" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="16" cy="5.6" r="1.5" fill="#ede9fe" />
      {/* Head. */}
      <rect x="8.5" y="9.5" width="15" height="13" rx="4.5" fill="#f5f3ff" />
      {/* Eyes. */}
      <circle cx="13" cy="15.5" r="1.7" fill="#7c3aed" />
      <circle cx="19" cy="15.5" r="1.7" fill="#7c3aed" />
      {/* Smile. */}
      <path
        d="M12.5 18.6c1 1.3 2.2 1.9 3.5 1.9s2.5-.6 3.5-1.9"
        fill="none"
        stroke="#7c3aed"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {/* Ears. */}
      <rect x="6.4" y="13.5" width="2.1" height="5" rx="1.05" fill="#ede9fe" />
      <rect x="23.5" y="13.5" width="2.1" height="5" rx="1.05" fill="#ede9fe" />
    </svg>
  );
}
